import React from "react";
import { QRScannerIcon } from "../../../components/svgComponents/QRScannerIcon";

const ReferralInput = ({
  label = "Referral address",
  referralAddress,
  handleReferralInputChange,
  placeholderValue = "Enter your referral address",
  inputRef,
  setIsCameraOpen,
  isTransfer,
}) => {
  return (
    <div className="flex flex-col gap-3 pt-3 pb-4 px-4 md:px-8 border-b border-lightGrayBlue dark:border-darkSlateBlue">
      <label
        htmlFor="referral-input"
        className="font-medium text-sm md:text-base leading-6 text-black dark:text-white"
      >
        {label}
      </label>
      <div className="relative w-full">
        <input
          ref={inputRef}
          className="font-inter pl-6 pr-12 py-2 md:py-5 bg-lightBlue text-black rounded-lg w-full text-base leading-6 
                  dark:text-white dark:bg-darkButBg placeholder:text-lightBlack dark:placeholder:text-lightWhite 
                  outline-none"
          id="referral-input"
          placeholder={placeholderValue}
          value={referralAddress}
          onChange={handleReferralInputChange}
        />

        {isTransfer && (
          <button
            onClick={() => setIsCameraOpen(true)}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
          >
            <QRScannerIcon className="w-6 h-6" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ReferralInput;
